import { Component, h, State } from '@stencil/core';
import { Translations } from '../../../helpers/TranslationUtils';
import { TranslationValues } from '../../../models/ITranslationValues';
import { ApiCall } from '../../../helpers/ApiCall';
import { delay } from '../../../utils/utils';
import store from '../../../helpers/store';
import logoOntrace from '../../../assets/logo-ontrace.svg';

@Component({
  tag: 'random-action',
  styleUrl: 'random-action.css',
  shadow: false,
})
export class RandomAction {
  private translations: TranslationValues;
  @State() private rand: number[] = [];
  @State() private choice: number;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();

    this.randomize();
  }

  private randomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  private randomize() {
    this.rand = [];

    for (let i = 0; i < 9; i++) {
      var generated = this.randomInt(1, 99);
      while (this.rand.includes(generated)) {
        generated = this.randomInt(1, 99);
      }
      this.rand.push(generated);
    }

    this.choice = this.randomInt(0, 8);
  }

  private async click(i: number, e: any) {
    let target = e.currentTarget;

    if (this.choice == i) {
      target.classList.add('success');
      await delay(500);
      store.flowStatus = await ApiCall.instance.GetNextFlowState();
    } else {
      target.classList.add('error');
      await delay(500);
      this.randomize();
    }

    target.classList = [];
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-2 w-100">
          <h1 class="text-center px-1 mb-2" innerHTML={this.translations.RandomActionValues.Title + ` ${this.rand[this.choice]}`}></h1>
          <div class="grid">
            {this.rand.map((number, i) => (
              <div onClick={e => this.click(i, e)}>{number}</div>
            ))}
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
